import { SessionConfig } from '@origin-digital/context-hub';

declare var global: {
  ContextHub: any;
};

export class ContextHubConnector {
  originPersistence = null;

  // lazy initialize, this gives the contexthub.kernel.js script time to async load
  // this should be done better
  getPersistence(): any {
    if (this.originPersistence == null) {
      // move this testing stub to another file?
      const contextStub = {
        getStore() {
          return {
            getItem() {
              /* TODO */
            },
            setItem() {
              /* TODO */
            },
          };
        },
      };
      // TODO maybe throw an error if contextHub isn't loaded
      // need to add support for testing
      const context = global.ContextHub || contextStub;
      this.originPersistence = SessionConfig.getOriginPersistence(context);
    }
    return this.originPersistence;
  }

  setPostalCode(postalCode: string) {
    // TODO these constants should be externalized
    this.getPersistence().setItem('plansearchpostcode', postalCode);
    this.getPersistence().setItem('postCode', postalCode);
    this.getPersistence().setItem('planfuel', 'Elec_Gas');
  }
}
